// extracted by mini-css-extract-plugin
module.exports = {"form-group":"Routes_form-group__CUFeC","appContainer":"Routes_appContainer__3Ewc6"};